export const isLocalUrl = (url: string) => {
  // Define regular expressions for IPv4 and IPv6 localhost variations
  const ipv4LocalhostPattern = /^(https?:\/\/)?(127\.0\.0\.1|localhost)(:\d+)?(\/.*)?$/i;
  const ipv6LocalhostPattern = /^(https?:\/\/)?(\[::1\]|localhost)(:\d+)?(\/.*)?$/i;

  // Check if the URL matches the patterns for IPv4 or IPv6 localhost addresses
  return ipv4LocalhostPattern.test(url) || ipv6LocalhostPattern.test(url);
}
